export default {
	baseURL:'http://106.14.81.90:8192/portal/',
	 // baseURL:'http://localhost:8099/portal_war_exploded/',
	// baseURL:'http://test.nssb.taxunion.com.cn:8999/nssb/',
	//baseURL:'http://fmiahewwqm.bastionhost.aliyuncs.com:8080/nssb/'
	// baseURL:'https://www.portal.philips.com.cn/ppserver/'
	//baseURL:'http://192.168.2.30:8234/pp/'
	mobileUrl: 'http://106.14.81.90:8193/mobile/'
}